
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cgv",
      function () {
        return require("private-next-pages/cgv.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cgv"])
      });
    }
  